import { Input } from '@components/styled/Input.styled';
import { Title } from '@components/styled/Title.styled';
import styled from 'styled-components';
import { fontHeadingMdLight } from '../../typography.styled';

export const MinRateGroup = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-items: center;
    row-gap: 25px;

    max-width: 640px;

    > ${Title} {
        margin: auto 0;
        ${fontHeadingMdLight}
        text-align: left;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-items: center;

    > ${Input} {
        margin: 0 15px 0 0;
    }
`;
